(() => {
  if (window.loufyPurchaseReady) return;
  window.loufyPurchaseReady = true;
  const consentFor = formId => formId === 'cart'
    ? ['Loufy-CGV-Page', 'checkout', '#main-cart-footer']
    : formId === 'CartDrawer-Form'
      ? ['Loufy-CGV-Drawer', 'CartDrawer-Checkout', '#CartDrawer'] : null;
  document.addEventListener('change', event => {
    if (!event.target.matches('.loufy-cgv-checkbox')) return;
    const config = event.target.id === 'Loufy-CGV-Page' ? consentFor('cart') : consentFor('CartDrawer-Form');
    const button = document.getElementById(config[1]);
    if (button) button.disabled = !event.target.checked;
    document.querySelector(config[2] + ' .loufy-cgv-error')?.setAttribute('hidden', '');
  });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (form.matches('[data-loufy-discount]')) {
      event.preventDefault();
      const input = form.querySelector('input[name="discount"]');
      const code = input.value.trim();
      if (!code) { input.focus(); return; }
      const root = window.Shopify?.routes?.root || '/';
      const destination = root + 'discount/' + encodeURIComponent(code);
      window.location.assign(destination + '?redirect=' + encodeURIComponent(form.dataset.cartUrl));
      return;
    }
    const config = consentFor(form.id);
    if (!config) return;
    if (!document.getElementById(config[0])?.checked) {
      event.preventDefault();
      document.querySelector(config[2] + ' .loufy-cgv-error')?.removeAttribute('hidden');
      document.getElementById(config[0])?.focus();
    }
  }, true);
})();
